import script from "./ApplicationLandingView.vue?vue&type=script&setup=true&lang=js"
export * from "./ApplicationLandingView.vue?vue&type=script&setup=true&lang=js"

import "./ApplicationLandingView.vue?vue&type=style&index=0&id=44fc4e7a&scoped=true&lang=css"

import exportComponent from "C:\\wamp64_old\\www\\configurator_vue_version_3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-44fc4e7a"]])

export default __exports__